import React, { useEffect, useState, useRef } from "react";
import "./editprofile.scss";
import Navbar from "../landing/header/Navbar";
import { Dropdown, Modal } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import { useWeb3React } from "@web3-react/core";
import allCities from "./allCities";
import Loader from "../../hooks/loader";
import CustomToast from '../../components/CustomToast';





const Editprofile = ({ setProfile }) => {
  const [show6, setShow6] = useState(false);

  const handleShow6 = () => setShow6(true);
  const [name, setName] = useState(null);
  const { account } = useWeb3React();
  const [imge, setImage] = useState(null);
  const [inputField, setInputField] = useState(null);
  const fileInputRef = useRef(null);
  const [inputFieldImge, setInputFieldImge] = useState(null);
  const [userData, setUserData] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);
  const [projectBannerImg, setProjectBannerImg] = useState(null);
  const [apiImage, setApiImage] = useState(null);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState([]); // Tracks selected type: 'digital' or 'physical'
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false); // Track if country dropdown is open
  const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false); // Track if city dropdown is open
  const countryInputRef = useRef(null); // Ref for country search input
  const cityInputRef = useRef(null); // Ref for city search input
  const handleClose6 = () => {
    handleClose79();
    navigate("/latesttask");
  };
  // console.log(apiImage, 'apiImage');

  const [categories, setCategories] = useState([
    {
      categoryName: "Logistics & Supply Chain",
      id: 15,
    },
  ]);
  // console.log(categories, 'categories');

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [originalEmail, setOriginalEmail] = useState(""); // Store the original email
  const [email, setEmail] = useState(""); // Track the current email
  const [isEmailVerified, setIsEmailVerified] = useState(false); // Track verification status

  const [show77, setShow77] = useState(false);

  const handleClose77 = () => setShow77(false);
  const handleShow77 = () => setShow77(true);

  const [show78, setShow78] = useState(false);

  const handleClose78 = () => setShow78(false);
  const handleShow78 = () => setShow78(true);

  const [show79, setShow79] = useState(false);

  const handleClose79 = () => setShow79(false);
  const handleShow79 = () => setShow79(true);
  // console.log(selectedType, 'selectedType');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const transformLocationData = (data) => {
    const transformedData = {};
    data.forEach((item) => {
      // Only add non-empty country and city arrays
      if (item.country && item.cities && item.cities.length > 0) {
        transformedData[item.country] = item.cities;
      }
    });
    return transformedData;
  };
  // Utility function to check if an object has at least one valid entry
  const hasValidEntries = (obj) => {
    return Object.keys(obj).some(
      (key) => Array.isArray(obj[key]) && obj[key].length > 0
    );
  };

  const [selectedDigitalCategories, setSelectedDigitalCategories] = useState(
    []
  );
  const [selectedPhysicalCategories, setSelectedPhysicalCategories] = useState(
    []
  );

  // This ensures only meaningful values enable the button
  const isFormValid =
    (inputField && inputField.trim() !== "") ||        // inputField is non-empty
    (email && email.trim() !== "") ||                  // email is non-empty
    selectedDigitalCategories.length > 0 ||            // at least one digital category selected
    selectedPhysicalCategories.length > 0;             // at least one physical category selected

  console.log(isFormValid, "isFormValid", inputField, email, selectedDigitalCategories, selectedPhysicalCategories);

  // const aditProfile = async () => {
  //     // if (!isEmailVerified){
  //     //     return toast.error("Email not verified!");
  //     // }

  //     // Validate each required field
  //     if (!inputField) {
  //         return toast.error("Name is required", {
  //             autoClose: 15000, // 15 seconds
  //         });
  //     }
  //     if (!apiImage) {
  //         return toast.error("Image is required", {
  //   autoClose: 15000, // 15 seconds
  // });
  //     }
  //     if (!email) {
  //         return toast.error("Email is required", {
  //   autoClose: 15000, // 15 seconds
  // });
  //     }

  //     if (!selectedType || selectedType.length === 0) {
  //         return toast.error("Service type is required", {
  //   autoClose: 15000, // 15 seconds
  // });
  //     }

  //     // Check if 'digital' type is selected and at least one digital category is chosen
  //     if (selectedType?.includes("digital") && (!selectedDigitalCategories || selectedDigitalCategories.length === 0)) {
  //         return toast.error("At least one digital category must be selected", {
  //   autoClose: 15000, // 15 seconds
  // });
  //     }

  //     // Check if 'physical' type is selected and at least one physical category is chosen
  //     if (selectedType?.includes("physical") && (!selectedPhysicalCategories || selectedPhysicalCategories.length === 0)) {
  //         return toast.error("At least one physical category must be selected", {
  //   autoClose: 15000, // 15 seconds
  // });
  //     }

  //     // Prepare payload with the validated fields
  //     let payload = {
  //         name: inputField,
  //         imageUrl: apiImage,
  //         email: email,
  //         serviceType: selectedType,
  //     };

  //     // Conditionally add the physicalCategoryIds if present
  //     if (selectedType?.includes("physical") && selectedPhysicalCategories && selectedPhysicalCategories.length > 0) {
  //         payload.physicalCategoryIds = selectedPhysicalCategories.map(item => item.id);
  //     }

  //     // Conditionally add the digitalCategoryIds if present
  //     if (selectedType?.includes("digital") && selectedDigitalCategories && selectedDigitalCategories.length > 0) {
  //         payload.digitalCategoryIds = selectedDigitalCategories.map(item => item.id);
  //     }

  //     // Add location if 'physical' type is included in serviceType
  //     if (selectedType?.includes("physical") && locations && locations.length > 0) {
  //         let result = transformLocationData(locations);

  //         // Check if result is a valid location data (remove empty entries)
  //         if (!hasValidEntries(result)) {
  //             return toast.error("Invalid location data. Please select valid locations.", {
  //                 autoClose: 15000, // 15 seconds
  //             });
  //         }

  //         payload.locations = result;
  //     }

  //     // Prepare the request configuration
  //     let accessToken = localStorage.getItem('accessToken');
  //     const config = {
  //         method: "patch",
  //         url: `${API_URL}users`,
  //         headers: {
  //             'Content-Type': 'application/json',
  //             'Authorization': `Bearer ${accessToken}`
  //         },
  //         data: payload,
  //     };

  //     try {
  //         const response = await axios(config);
  //         if (response) {
  //             handleShow6();
  //             getProfile()
  //         }
  //     } catch (error) {
  //         console.error('Error occurred while updating profile:', error);

  //         // Check if the error has a response from the API
  //         const errorMessage = error.response?.data?.message || "Unknown error occurred";

  //         toast.error(`Error updating profile: ${errorMessage}. Please try again.`, {
  //             autoClose: 15000, // 15 seconds
  //         });

  //     }
  // };

  // // console.log(inputField , !apiImage , !email , (!selectedType || selectedType.length === 0), 'kanaa');


  const aditProfile = async () => {

    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (email && !isValid) {
      CustomToast.show("error", "Error", "invalid email address!");
      return
    }

    // Check if all fields are empty
    if (
      !inputField &&
      !apiImage &&
      !email &&
      (!selectedType || selectedType.length === 0)
    ) {
      // return toast.error(
      //   "At least one field must be filled to submit the form.",
      //   {
      //     autoClose: 15000, // 15 seconds
      //   }
      // );
      return CustomToast.show("error", "Error", "At least one field must be filled to submit the form.");
    }

    // Validate serviceType and categories
    if (
      selectedType?.includes("digital") &&
      (!selectedDigitalCategories || selectedDigitalCategories.length === 0)
    ) {
      // return toast.error(
      //   "At least one digital category must be selected when 'digital' service type is chosen.",
      //   {
      //     autoClose: 15000, // 15 seconds
      //   }
      // );
      return CustomToast.show("error", "Error", "At least one digital category must be selected when 'digital' service type is chosen.");
    }

    if (
      selectedType?.includes("physical") &&
      (!selectedPhysicalCategories || selectedPhysicalCategories.length === 0)
    ) {
      // return toast.error(
      //   "At least one physical category must be selected when 'physical' service type is chosen.",
      //   {
      //     autoClose: 15000, // 15 seconds
      //   }
      // );
      return CustomToast.show("error", "Error", "At least one physical category must be selected when 'physical' service type is chosen.");
    }

    //physical category is chosen but location not chosen
    if (
      selectedType?.includes("physical") &&
      selectedPhysicalCategories &&
      selectedPhysicalCategories.length > 0 &&
      locations &&
      locations[locations.length - 1]?.country === ""
    ) {
      // return toast.error(
      //   "At least one location must be added when 'physical' service type is chosen.",
      //   {
      //     autoClose: 15000, // 15 seconds
      //   }
      // );
      return CustomToast.show("error", "Error", "At least one location must be added when 'physical' service type is chosen.");
    }

    // Validate location if 'physical' is included
    if (
      selectedType?.includes("physical") &&
      locations &&
      locations.length > 0
    ) {
      let result = transformLocationData(locations);

      if (!hasValidEntries(result)) {
        // return toast.error(
        //   "Invalid location data. Please select valid locations.",
        //   {
        //     autoClose: 15000, // 15 seconds
        //   }
        // );
        return CustomToast.show("error", "Error", "Invalid location data. Please select valid locations.");
      }
    }

    // Prepare payload with the provided fields
    let payload = {};
    if (inputField) payload.name = inputField;
    if (apiImage) payload.imageUrl = apiImage;
    if (email) payload.email = email;
    if (selectedType && selectedType.length > 0)
      payload.serviceType = selectedType;

    // Add physical categories if present
    if (
      selectedType?.includes("physical") &&
      selectedPhysicalCategories &&
      selectedPhysicalCategories.length > 0
    ) {
      payload.physicalCategoryIds = selectedPhysicalCategories.map(
        (item) => item.id
      );
    }

    // Add digital categories if present
    if (
      selectedType?.includes("digital") &&
      selectedDigitalCategories &&
      selectedDigitalCategories.length > 0
    ) {
      payload.digitalCategoryIds = selectedDigitalCategories.map(
        (item) => item.id
      );
    }

    // Add locations if present and valid
    if (
      selectedType?.includes("physical") &&
      locations &&
      locations.length > 0
    ) {
      payload.locations = transformLocationData(locations);
    }

    // Prepare the request configuration
    let accessToken = localStorage.getItem("accessToken");
    const config = {
      method: "patch",
      url: `${API_URL}users`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      data: payload,
    };

    try {
      const response = await axios(config);
      if (response) {
        handleShow6();
        setProfile(response)
        getProfile();
      }
    } catch (error) {
      console.error("Error occurred while updating profile:", error);

      // const errorMessage =
      //   error.response?.data?.message || "Unknown error occurred";

      // toast.error(
      //   `Error updating profile: ${errorMessage}. Please try again.`,
      //   {
      //     autoClose: 15000, // 15 seconds
      //   }
      // );
      CustomToast.show("error", "Error", `${error}`);
    }
  };

  const handleBannerClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    // Allowed file types
    const allowedFileTypes = ["image/png", "image/jpg", "image/jpeg"];
    if (!allowedFileTypes.includes(file.type)) {
      // toast.error("Only PNG, JPG, and JPEG files are allowed.", {
      //   autoClose: 15000, // 15 seconds
      // });
      CustomToast.show("error", "Error", "Only PNG, JPG, and JPEG files are allowed.");
      return;
    }

    const imageUrl = URL.createObjectURL(file);
    // console.log(file, imageUrl, 'imageUrl');

    // Set state to show the uploaded image
    setBannerImage(file);
    setProjectBannerImg(imageUrl);
    setApiImage(imageUrl);
    imgeUrl(file); // Upload image to API
  };

  const imgeUrl = async (e) => {
    setLoader(true)
    // console.log(e, 'e');
    let accessToken = localStorage.getItem("accessToken");

    // Create a FormData object to send the image
    let formData = new FormData();
    formData.append("image", e); // Assuming 'e' is the image file

    var config = {
      method: "post",
      url: `${API_URL}metadata/upload-image`,
      headers: {
        "Content-Type": "multipart/form-data", // Correct content type for file uploads
        Authorization: `Bearer ${accessToken}`,
      },
      data: formData, // Send formData with the image file
    };

    try {
      let response = await axios(config);
      if (response) {
        // console.log(response.data.url, 'response');
        setApiImage(response.data.url);
      }
      setLoader(false)
    } catch (error) {
      console.error("Error occurred while uploading image:", error);
      setLoader(false)
    }
  };
  const inputHandler = (e) => {
    setInputField(e.target.value);
  };
  const reverseTransformLocationData = (data) => {
    const reversedData = [];
    let id = 1; // Start ID from 1 or any specific value as per your requirement

    for (const [country, cities] of Object.entries(data)) {
      reversedData.push({
        id: id++, // Increment the ID for each country
        country: country,
        cities: cities,
        searchTermCt: "",
        searchTermCity: "",
      });
    }

    return reversedData;
  };
  const getProfile = async () => {
    let accessToken = localStorage.getItem("accessToken");
    var config = {
      method: "get",
      url: `${API_URL}users`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
    };
    try {
      setLoader(true);
      let response = await axios(config);

      if (response) {
        // console.log('Task created successfully:', response?.data?.data);
        setProjectBannerImg(response?.data?.data?.imageUrl);
        setInputField(response?.data?.data?.name);
        setApiImage(response?.data?.data?.imageUrl);
        setEmail(response?.data?.data?.email);
        response?.data?.data?.serviceType
          ? setSelectedType(response?.data?.data?.serviceType)
          : setSelectedType([]);
        setSelectedDigitalCategories(
          response?.data?.data?.digitalCategories || []
        );
        setSelectedPhysicalCategories(
          response?.data?.data?.physicalCategories || []
        );
        let transformedBackData =
          response.data.data.locations &&
          reverseTransformLocationData(response.data.data.locations);
        setUserData(response?.data?.data);
        // Set the reversed data to the locations state

        transformedBackData?.length > 0 && setLocations(transformedBackData);
        // console.log("");
        setOriginalEmail(response?.data?.data?.email);
        setEmail(response?.data?.data?.email);
        setIsEmailVerified(response?.data?.data?.isEmailVerified);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error occurred while creating task:", error);
    }
  };
  // Step 1: Send OTP to Email
  const sendOtp = async () => {

    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (email && !isValid) {
      CustomToast.show("error", "Error", "invalid email address!");
      return
    }

    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await fetch(`${API_URL}users/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        handleShow77();
      } else {
        const errorData = await response.json(); // Get error message from response
        // toast.error(
        //   errorData?.message || "Failed to send OTP. Please try again.",
        //   {
        //     autoClose: 15000, // 15 seconds
        //   }
        // );
        CustomToast.show("error", "Error", errorData?.message || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      // toast.error("An error occurred. Please check your network connection.", {
      //   autoClose: 15000, // 15 seconds
      // });
      CustomToast.show("error", "Error", "An error occurred. Please check your network connection.");
    }
  };

  // Step 2: Verify OTP

  const verifyOtp = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const otpCode = otp.join(""); // Concatenate OTP array
    // console.log(otpCode?.length, 'otpCode?.length ');
    if (otpCode?.length < 6) {
      toast.error("Invalid OTP code", {
        autoClose: 15000, // 15 seconds
      });
      return;
    }
    try {
      const response = await fetch(`${API_URL}users/verify-otp`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ otp: otpCode }),
      });

      if (response.ok) {
        getProfile();
        handleShow78();
        handleClose77();
      } else {
        const errorMessage = await response.text(); // Optional: Extract error message from response
        // toast.error(`Failed to verify OTP. ${errorMessage || "Please try again."}`);
        // toast.error(`Failed to verify OTP.`);
        CustomToast.show("error", "Error", `Failed to verify OTP. ${errorMessage || "Please try again."}`);
      }
    } catch (error) {
      // toast.error(`Something went wrong. ${error.message}`, {
      //   autoClose: 15000, // 15 seconds
      // });
      CustomToast.show("error", "Error", `Something went wrong. ${error.message}`);
      console.error("Error verifying OTP:", error);
    }
  };

  // Handle OTP input change and focus
  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (value.match(/^[0-9]$/)) {
      // Ensure single digit
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < otp.length - 1)
        document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  // Handle OTP backspace and focus
  const handleOtpBackspace = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      if (otp[index] === "" && index > 0) {
        // Focus the previous input if the current one is empty
        document.getElementById(`otp-${index - 1}`).focus();
      } else {
        // Clear the current input
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  const fetchTasksCategories = async () => {
    try {
      const response = await fetch(`${API_URL}tasks-categories?limit=${50}`, {
        method: "GET", // HTTP method
        headers: {
          "Content-Type": "application/json", // Set the content type if needed
          // No authorization header needed since you're not using an access token
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      // console.log(data?.data?.taskCategories, 'ddddddd');

      setCategories(data?.data?.taskCategories);
      // console.log(data?.data, 'datasdDS'); // Handle your data here
    } catch (error) {
      console.error("Error fetching tasks categories:", error);
    }
  };



  // Functions to handle Digital category selections
  // console.log(selectedDigitalCategories, 'selectedDigitalCategories?.includes(category)');

  // Update Digital Category
  const addDigitalCategory = (category) => {
    if (
      !selectedDigitalCategories.some(
        (item) => item.categoryName === category.categoryName
      )
    ) {
      setSelectedDigitalCategories([...selectedDigitalCategories, category]);
    }
  };

  // Update Physical Category
  const addPhysicalCategory = (category) => {
    if (
      !selectedPhysicalCategories.some(
        (item) => item.categoryName === category.categoryName
      )
    ) {
      setSelectedPhysicalCategories([...selectedPhysicalCategories, category]);
    }
  };
  // Remove Digital Category
  const removeDigitalCategory = (category) => {
    setSelectedDigitalCategories(
      selectedDigitalCategories.filter(
        (item) => item.categoryName !== category.categoryName
      )
    );
  };

  // Remove Physical Category
  const removePhysicalCategory = (category) => {
    setSelectedPhysicalCategories(
      selectedPhysicalCategories.filter(
        (item) => item.categoryName !== category.categoryName
      )
    );
  };

  const handleCheckboxChange = (type) => {
    // Create a copy of the current selectedType array
    let updatedArray = [...selectedType];

    if (updatedArray?.includes(type)) {
      // If the type is already in the array, remove it
      updatedArray = updatedArray.filter((item) => item !== type);
    } else {
      // If the type is not in the array, add it
      updatedArray.push(type);
    }

    // Update the state with the new array
    setSelectedType(updatedArray);
  };

  // console.log(selectedType, selectedDigitalCategories?.map((item) => item?.id), selectedPhysicalCategories, email, 'selectedType');

  const [selectedCities, setSelectedCities] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const cities = [
    "Auckland",
    "Christchurch",
    "Wellington",
    "Hamilton",
    "Tauranga",
  ];

  // Handle checkbox toggle for each city
  // const handleCityToggle = (city) => {
  //     setSelectedCities((prevSelectedCities) =>
  //         prevSelectedCities?.includes(city)
  //             ? prevSelectedCities.filter((c) => c !== city)
  //             : [...prevSelectedCities, city]
  //     );
  // };

  // Remove city when clicking the button SVG
  const removeCity = (city) => {
    setSelectedCities((prevSelectedCities) =>
      prevSelectedCities.filter((c) => c !== city)
    );
  };

  // Filter cities based on search term
  const filteredCities = cities.filter((city) =>
    city.toLowerCase()?.includes(searchTerm.toLowerCase())
  );

  //country
  const [selectedCountry, setSelectedCountry] = useState(""); // Track selected country
  const [searchTermCt, setSearchTermCt] = useState(""); // Track search input

  const countries = Object.keys(allCities);
  // const [countries, setCountries] =useState([])
  // const [allCities, setAllCities] = useState([])
  // // console.log(countries,'countriescountries');

  // Filter countries based on search term
  const filteredCountries = countries.filter((country) =>
    country.toLowerCase()?.includes(searchTermCt.toLowerCase())
  );

  const [locations, setLocations] = useState([
    { id: 1, country: "", cities: [], searchTermCt: "", searchTermCity: "" },
  ]);
  // console.log("Locations are declaration,", locations);

  // const [countries] = useState(["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Pakistan"]);

  // Function to add a new location
  const addLocation = () => {
    // console.log("Locationssssssss areeeeee :", locations);
    // console.log(locations[locations.length - 1]);
    if (locations[locations.length - 1].country === "") {
      // toast.error(
      //   "Please choose a country and a city before adding another location."
      // );

      CustomToast.show("error", "Error", "Please choose a country and a city before adding another location.");
      return;
    }
    setLocations([
      ...locations,
      {
        id: locations.length + 1,
        country: "",
        cities: [],
        searchTermCt: "",
        searchTermCity: "",
      },
    ]);
  };

  // Function to remove a location
  const removeLocation = (id) => {
    if (locations.length > 1) {
      setLocations(locations.filter((location) => location.id !== id));
    }
  };

  // Handle country selection
  const handleCountryChange = (id, country) => {
    setLocations(
      locations.map((loc) =>
        loc.id === id
          ? { ...loc, country, cities: [], searchTermCity: "" }
          : loc
      )
    );
  };

  // Toggle city selection
  const handleCityToggle = (id, city) => {
    setLocations(
      locations.map((loc) =>
        loc.id === id
          ? {
            ...loc,
            cities: loc.cities?.includes(city)
              ? loc.cities.filter((c) => c !== city)
              : [...loc.cities, city],
          }
          : loc
      )
    );
  };

  // Get a list of all selected countries to exclude from the dropdown options
  const selectedCountries = locations
    .map((location) => location.country)
    .filter(Boolean);

  // console.log(locations, 'locations');

  useEffect(() => {
    //        // Fetch list of countries
    fetch("https://restcountries.com/v3.1/all")
      .then((response) => response.json())
      .then();

    // Fetch cities in a country (replace "US" with the country code)
    fetch(
      "http://api.geonames.org/searchJSON?country=GS&maxRows=1000&username=tomitask"
    )
      .then((response) => response.json())
      .then();
    // const BASE_URL = 'https://countriesnow.space/api/v0.1/countries';

    // let getCountries = async () => {
    //     const response = await fetch(`${BASE_URL}`).then(response => response.json());
    //     const { data } = response;

    //     // Extract just the country names
    //     const countryNames = data.map(country => country.country);

    //     // Build the allCities object with countries as keys and cities as values
    //     const allCities = data.reduce((acc, country) => {
    //         acc[country.country] = country.cities;
    //         return acc;
    //     }, {});

    //     // Assuming setCountries and setAllCities are functions to update state
    //     setCountries(countryNames); // Update countries state with only names
    //     setAllCities(allCities);    // Update allCities state with country-city mapping
    // };

    // getCountries()
  }, []);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    // If the entered email is the same as the original, keep it verified; otherwise, unverify it
    setIsEmailVerified(newEmail === originalEmail);
  };
  const removeImage = async () => {
    setProjectBannerImg(""); // Remove the image preview
    setBannerImage(null); // Clear banner image state
    setApiImage(null); // Clear the API image state
    fileInputRef.current.value = null; // Reset file input field
    const accessToken = localStorage.getItem("accessToken");
    // Call API to delete the image
    const imageUrl = projectBannerImg; // Get the current image URL

    if (!imageUrl) {
      console.warn("No image URL to delete.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}metadata/upload-image`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          imageUrl: imageUrl,
          isProfile: true,
        }),
      });

      if (response.ok) {
        // console.log("Image successfully deleted.");
      } else {
        console.error("Failed to delete image. Status:", response.status);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  // Focus the country input when the dropdown is opened
  useEffect(() => {
    if (isCountryDropdownOpen) {
      countryInputRef.current?.focus();
    }
  }, [isCountryDropdownOpen]);

  // Focus the city input when the dropdown is opened
  useEffect(() => {
    if (isCityDropdownOpen) {
      cityInputRef.current?.focus();
    }
  }, [isCityDropdownOpen]);

  useEffect(() => {
    fetchTasksCategories();
  }, []);
  // console.log(userData, 'userData');

  useEffect(() => {
    getProfile();
  }, []);
  return (
    <>
      {loader && <Loader />}
      {/* <Navbar /> */}
      <section className="mainedit">
        <div className="custom-container">
          <a href="" target="_blank" className="edithead">
            Home / <span> Edit Profile</span>
          </a>
          <h2 className="heading">Edit Profile</h2>
          {/* <div className='mainbox'>
                        <div className='left'>
                            <div className='innerleft'>
                                <div className='first'>
                                    <div className='mainimg' >
                                        <img src={projectBannerImg ? projectBannerImg : '/assets/edituploadimg.png'} alt='img' className='img-fluid innerimg' />
                                    </div>
                                </div>
                                <div className='second'>
                                    <h4>Profile Image</h4>
                                    <p>For best results, upload an image with a resolution of 500x500 pixels. Please use JPEG or PNG format, with a maximum file size of 5 MB.</p>
                                    <div className='parentbuttonss'>
                                        {
                                            projectBannerImg && <button onClick={() => setProjectBannerImg("")} className='remove'>Remove</button>
                                        }

                                        <div className='wrapper' onClick={handleBannerClick}>
                                            <label htmlFor='' className='uploadbtn'>
                                                Change
                                            </label>
                                            <input ref={fileInputRef} onChange={handleImageUpload} type='file' id='' placeholder='hhhhhhhhhh' className='d-none' />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='right'>
                            <div className='maininput'>
                                <p>Full Name</p>

                                <input type='text' placeholder='enter your name' value={inputField} onChange={inputHandler} />
                            </div>
                            <div className='twicebutton'>
                                <button className='back' onClick={handleClose6}>Go Back</button>
                                <button onClick={aditProfile} className='save'>Save Changes</button>
                            </div>
                        </div>
                    </div> */}

          <div className="mainbox">
            <div className="parentbox">
              <div className="first">
                <h3>Basic Information</h3>
                <p>Enter your basic information</p>
              </div>
              <div className="second">
                <div className="parentinnertext">
                  <div className="firstinner">
                    <div className="mainimg">
                      <img
                        src={
                          projectBannerImg
                            ? projectBannerImg
                            : "https://d1ldvrgz5vrwdc.cloudfront.net/tomi-army/trustless-rewards/placeholders/Frame 2147227155.png"
                        }
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                  </div>
                  <div className="secondinner">
                    <h3>Profile Image</h3>
                    <p>
                      We recommend uploading an image with a resolution of
                      500x500 pixels. Max 5 MB in JPEG or PNG format.
                    </p>
                    <div className="twicebutton">
                      <div className="maininput">
                        <div className="wrapper ">
                          <label htmlFor="upload" className="upload cp">
                            Upload
                          </label>
                          <input
                            ref={fileInputRef}
                            onChange={handleImageUpload}
                            type="file"
                            id="upload"
                            className="d-none"
                          />
                        </div>
                        {projectBannerImg && (
                          <button onClick={removeImage} className="remove">
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="twoinputs">
                  <div className="left">
                    <div className="maininputs">
                      <p>Full Name</p>
                      <input
                        type="text"
                        placeholder="Enter your name..."
                        value={inputField}
                        onChange={inputHandler}
                      />
                    </div>
                  </div>
                  <div className="left ">
                    <div className="maininputs">
                      <p>Wallet Address</p>
                      <input
                        className="secondddddmain"
                        disabled
                        type="text"
                        value={`${account?.slice(0, 12)}...${account?.slice(
                          -12
                        )}`}
                        placeholder="0x73DB1E348DEE57320...EDB"
                      />
                      <h6>Connected</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mainbox">
            <div className="parentbox">
              <div className="first">
                <h3>Participant Profile</h3>
                <p className="paraaaa">
                  Enter more details about the tasks you wish to participate in.
                  This will help us notify you when a relevant task that matches
                  your interests and expertise is added to the site.
                </p>
              </div>
              <div className="second">
                <div className="parentsecond">
                  <div className="maininput">
                    <p>Email Address</p>
                    <input
                      type="text"
                      placeholder="johndoe@email.com"
                      value={email}
                      onChange={handleEmailChange}
                      disabled={isEmailVerified}
                    />
                    {isEmailVerified ? (
                      // <img src="/assets/verified.svg" className='' alt="" srcset="" />
                      <button
                        style={{ maxWidth: "70px" }}
                        className="verify bg-success text-light pe-3"
                      >
                        Verified
                      </button>
                    ) : (
                      <>
                        {
                          <button
                            className="verify"
                            disabled={!email}
                            onClick={() => {
                              if (!email) return;
                              setOtp(["", "", "", "", "", ""]);
                              sendOtp();
                            }}
                            style={{
                              opacity: email ? 1 : 0.5,
                              cursor: email ? "pointer" : "not-allowed"
                            }}
                          >
                            Verify
                          </button>
                        }
                      </>
                    )}
                  </div>
                </div>
                <div className="maintexttt">
                  <h6>Service Type</h6>
                  <div className="mainboxxxx">
                    <div className="checkboxmain">
                      <label className="checkbox" htmlFor="yellow">
                        <input
                          type="checkbox"
                          name="color"
                          value="yellow"
                          id="yellow"
                          checked={selectedType?.includes("digital")}
                          onChange={() => handleCheckboxChange("digital")}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <p className="checkboxpara">Digital (worldwide)</p>
                    </div>
                    {selectedType?.includes("digital") && (
                      <div className="mainboxtext">
                        <h6 className="upper">Service Category</h6>
                        <div className="servicecategorybuttons">
                          {selectedDigitalCategories.map((category, index) => (
                            <button key={index}>
                              {category?.categoryName}
                              <svg
                                onClick={() => removeDigitalCategory(category)}
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                              >
                                <path
                                  d="M8.99998 8.99998L6.00001 6.00001M6.00001 6.00001L3 3M6.00001 6.00001L9.00002 3M6.00001 6.00001L3 9.00002"
                                  stroke="#013159"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          ))}
                        </div>
                        <h6 className="upper">Pick Service Category</h6>
                        <div className="parentsbuttons">
                          <div className="innerbuttons">
                            {categories
                              ?.filter(
                                (category) =>
                                  !selectedDigitalCategories?.some(
                                    (item) =>
                                      item?.categoryName ===
                                      category?.categoryName
                                  )
                              )
                              ?.map((category, index) => (
                                <button
                                  key={index}
                                  onClick={() => addDigitalCategory(category)}
                                >
                                  {category?.categoryName}
                                </button>
                              ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="maintexttt">
                  {/* <h6>Service Type</h6> */}
                  <div className="mainboxxxx">
                    <div className="checkboxmain">
                      <label class="checkbox" for="yellow1">
                        <input
                          type="checkbox"
                          name="color"
                          value="yellow1"
                          id="yellow1"
                          checked={selectedType?.includes("physical")}
                          onChange={() => handleCheckboxChange("physical")}
                        />
                        <span class="checkmark"></span>
                      </label>
                      <p className="checkboxpara">
                        Physical (specific location)
                      </p>
                    </div>
                    {selectedType?.includes("physical") && (
                      <div className="mainboxtext">
                        <h6 className="upper">Service Category</h6>
                        {/* <p className='para'>From the list below, select at least one category that matches your interests and expertise.</p> */}
                        <div className="servicecategorybuttons">
                          {selectedPhysicalCategories.map((category, index) => (
                            <button key={index}>
                              {category?.categoryName}
                              <svg
                                onClick={() => removePhysicalCategory(category)}
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                              >
                                <path
                                  d="M8.99998 8.99998L6.00001 6.00001M6.00001 6.00001L3 3M6.00001 6.00001L9.00002 3M6.00001 6.00001L3 9.00002"
                                  stroke="#013159"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          ))}
                        </div>
                        <h6 className="upper">Pick Service Category</h6>
                        <div className="parentsbuttons">
                          <div className="innerbuttons">
                            {categories
                              ?.filter(
                                (category) =>
                                  !selectedPhysicalCategories?.some(
                                    (item) =>
                                      item?.categoryName ===
                                      category?.categoryName
                                  )
                              )
                              ?.map((category, index) => (
                                <button
                                  key={index}
                                  onClick={() => addPhysicalCategory(category)}
                                >
                                  {category?.categoryName}
                                </button>
                              ))}
                          </div>
                        </div>
                        <div className="brdr"></div>
                        {/* <div className='locationparent'>
                                                <h3>Specify your location</h3>
                                                <div className='threedrop'>
                                                    <div className='first forwidthhhhhhhhh'>
                                                        <h2>Country</h2>
                                                        <div className='maindrop'>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                    {selectedCountry || 'Select country'}
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                    >
                                                                        <path
                                                                            d="M13.3332 8.3335L9.99984 11.6668L6.6665 8.3335"
                                                                            stroke="#013159"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <div className='maintextdrop'>
                                                                        <div className='mainsinputsssss'>
                                                                            <input
                                                                                type='text'
                                                                                placeholder='Search...'
                                                                                value={searchTermCt}
                                                                                onChange={(e) => setSearchTermCt(e.target.value)}
                                                                            />
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                viewBox="0 0 16 16"
                                                                                fill="none"
                                                                            >
                                                                                <path
                                                                                    d="M14.3539 13.6464L11.2245 10.5176C12.1315 9.42871 12.5838 8.03201 12.4873 6.6181C12.3908 5.20419 11.7528 3.88193 10.7062 2.92637C9.65963 1.97082 8.28492 1.45555 6.86808 1.48775C5.45125 1.51995 4.10137 2.09714 3.09926 3.09926C2.09714 4.10137 1.51995 5.45125 1.48775 6.86808C1.45555 8.28492 1.97082 9.65963 2.92637 10.7062C3.88193 11.7528 5.20419 12.3908 6.6181 12.4873C8.03201 12.5838 9.42871 12.1315 10.5176 11.2245L13.6464 14.3539C13.6928 14.4003 13.748 14.4372 13.8087 14.4623C13.8694 14.4875 13.9344 14.5004 14.0001 14.5004C14.0658 14.5004 14.1309 14.4875 14.1916 14.4623C14.2523 14.4372 14.3074 14.4003 14.3539 14.3539C14.4003 14.3074 14.4372 14.2523 14.4623 14.1916C14.4875 14.1309 14.5004 14.0658 14.5004 14.0001C14.5004 13.9344 14.4875 13.8694 14.4623 13.8087C14.4372 13.748 14.4003 13.6928 14.3539 13.6464ZM2.50014 7.00014C2.50014 6.11013 2.76406 5.2401 3.25853 4.50008C3.753 3.76006 4.4558 3.18328 5.27807 2.84268C6.10033 2.50209 7.00513 2.41298 7.87805 2.58661C8.75096 2.76024 9.55279 3.18883 10.1821 3.81816C10.8115 4.4475 11.24 5.24932 11.4137 6.12224C11.5873 6.99515 11.4982 7.89995 11.1576 8.72222C10.817 9.54449 10.2402 10.2473 9.50021 10.7418C8.76019 11.2362 7.89016 11.5001 7.00014 11.5001C5.80707 11.4988 4.66325 11.0243 3.81962 10.1807C2.976 9.33704 2.50147 8.19321 2.50014 7.00014Z"
                                                                                    fill="#013159"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                        <div className='country'>
                                                                            <div className='inner'>
                                                                                {filteredCountries.map((country, index) => (
                                                                                    <p
                                                                                        key={index}
                                                                                        onClick={() => {
                                                                                            setSelectedCountry(country);
                                                                                            setSearchTerm(''); 
                                                                                        }}
                                                                                    >
                                                                                        {country}
                                                                                    </p>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                    <div className='first'>
                                                        <h2>City</h2>
                                                        <div className='maindrop'>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                    <div className='parentssssbuttonsss'>
                                                                        {selectedCities.length === 0 ? (
                                                                            <span>Select city</span> 
                                                                        ) : (
                                                                            selectedCities.map((city, index) => (
                                                                                <button key={index}>
                                                                                    {city}
                                                                                    <svg
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            removeCity(city);
                                                                                        }}
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="12"
                                                                                        height="12"
                                                                                        viewBox="0 0 12 12"
                                                                                        fill="none"
                                                                                    >
                                                                                        <path
                                                                                            d="M8.99998 8.99998L6.00001 6.00001M6.00001 6.00001L3 3M6.00001 6.00001L9.00002 3M6.00001 6.00001L3 9.00002"
                                                                                            stroke="#013159"
                                                                                            strokeWidth="1.5"
                                                                                            strokeLinecap="round"
                                                                                            strokeLinejoin="round"
                                                                                        />
                                                                                    </svg>
                                                                                </button>
                                                                            ))
                                                                        )}
                                                                    </div>
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 20 20"
                                                                        fill="none"
                                                                    >
                                                                        <path
                                                                            d="M13.3332 8.3335L9.99984 11.6668L6.6665 8.3335"
                                                                            stroke="#013159"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <div className='maintextdrop'>
                                                                        <div className='mainsinputsssss'>
                                                                            <input
                                                                                type='text'
                                                                                placeholder='Search...'
                                                                                value={searchTerm}
                                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                                            />
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                viewBox="0 0 16 16"
                                                                                fill="none"
                                                                            >
                                                                                <path
                                                                                    d="M14.3539 13.6464L11.2245 10.5176C12.1315 9.42871 12.5838 8.03201 12.4873 6.6181C12.3908 5.20419 11.7528 3.88193 10.7062 2.92637C9.65963 1.97082 8.28492 1.45555 6.86808 1.48775C5.45125 1.51995 4.10137 2.09714 3.09926 3.09926C2.09714 4.10137 1.51995 5.45125 1.48775 6.86808C1.45555 8.28492 1.97082 9.65963 2.92637 10.7062C3.88193 11.7528 5.20419 12.3908 6.6181 12.4873C8.03201 12.5838 9.42871 12.1315 10.5176 11.2245L13.6464 14.3539C13.6928 14.4003 13.748 14.4372 13.8087 14.4623C13.8694 14.4875 13.9344 14.5004 14.0001 14.5004C14.0658 14.5004 14.1309 14.4875 14.1916 14.4623C14.2523 14.4372 14.3074 14.4003 14.3539 14.3539C14.4003 14.3074 14.4372 14.2523 14.4623 14.1916C14.4875 14.1309 14.5004 14.0658 14.5004 14.0001C14.5004 13.9344 14.4875 13.8694 14.4623 13.8087C14.4372 13.748 14.4003 13.6928 14.3539 13.6464ZM2.50014 7.00014C2.50014 6.11013 2.76406 5.2401 3.25853 4.50008C3.753 3.76006 4.4558 3.18328 5.27807 2.84268C6.10033 2.50209 7.00513 2.41298 7.87805 2.58661C8.75096 2.76024 9.55279 3.18883 10.1821 3.81816C10.8115 4.4475 11.24 5.24932 11.4137 6.12224C11.5873 6.99515 11.4982 7.89995 11.1576 8.72222C10.817 9.54449 10.2402 10.2473 9.50021 10.7418C8.76019 11.2362 7.89016 11.5001 7.00014 11.5001C5.80707 11.4988 4.66325 11.0243 3.81962 10.1807C2.976 9.33704 2.50147 8.19321 2.50014 7.00014Z"
                                                                                    fill="#013159"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                        <div className='parentchec'>
                                                                            {filteredCities.map((city, index) => (
                                                                                <div key={index} className='mainchec'>
                                                                                    <div className="checkboxmainss">
                                                                                        <label className="checkbox" htmlFor={city}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={city}
                                                                                                checked={selectedCities?.includes(city)}
                                                                                                onChange={() => handleCityToggle(city)}
                                                                                            />
                                                                                            <span className="checkmark"></span>
                                                                                        </label>
                                                                                        <p className="checkboxpara">{city}</p>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                    <div className='seconddddddddd'>
                                                        <div className='red'>
                                                            <div className='close'>
                                                                <img src='\assets\Close_MD.png' alt='img' className='innerclose' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='locationbtn'>
                                                    <button>Add Another Location</button>
                                                </div>
                                            </div> */}
                        <div className="locationparent">
                          <h3>Specify your location</h3>
                          {locations.map((location, index) => (
                            <div className="threedrop mt-3" key={location.id}>
                              {/* Country Dropdown */}
                              <div className="first ">
                                <h2>Country</h2>
                                <div className="maindrop">
                                  <Dropdown onToggle={(isOpen) => setIsCountryDropdownOpen(isOpen)}>
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      {location.country || "Select country"}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                      >
                                        <path
                                          d="M13.3332 8.3335L9.99984 11.6668L6.6665 8.3335"
                                          stroke="#013159"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu >
                                      <div className="maintextdrop">
                                        <div className="mainsinputsssss">
                                          <input
                                            type="text"
                                            ref={countryInputRef} // Attach ref
                                            placeholder="Search..."
                                            value={location.searchTermCt}
                                            onChange={(e) => {
                                              const term = e.target.value;
                                              setLocations(
                                                locations.map((loc) =>
                                                  loc.id === location.id
                                                    ? {
                                                      ...loc,
                                                      searchTermCt: term,
                                                    }
                                                    : loc
                                                )
                                              );
                                            }}
                                          />
                                        </div>
                                        <div className="country">
                                          <div className="inner">
                                            {countries
                                              .filter(
                                                (country) =>
                                                  !selectedCountries?.includes(
                                                    country
                                                  ) ||
                                                  location.country === country
                                              )
                                              .filter((country) =>
                                                country
                                                  .toLowerCase()
                                                  ?.includes(
                                                    location.searchTermCt.toLowerCase()
                                                  )
                                              )
                                              .map((country, index) => (
                                                <Dropdown.Item
                                                  className="dropsssss"
                                                  key={index}
                                                  onClick={() =>
                                                    handleCountryChange(
                                                      location.id,
                                                      country
                                                    )
                                                  }
                                                >
                                                  {country}
                                                </Dropdown.Item>
                                              ))}
                                          </div>
                                        </div>
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>

                              {/* City Dropdown */}
                              <div className="first">
                                <h2>City</h2>
                                <div className="maindrop">
                                  <Dropdown onToggle={(isOpen) => setIsCityDropdownOpen(isOpen)}>
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                      disabled={!location.country}
                                    >
                                      <div className="parentssssbuttonsss">
                                        {location.cities.length === 0 ? (
                                          <span>Select city</span>
                                        ) : (
                                          location.cities.map((city, index) => (
                                            <button key={index}>
                                              {city}
                                              <svg
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleCityToggle(
                                                    location.id,
                                                    city
                                                  );
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="12"
                                                height="12"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                              >
                                                <path
                                                  d="M8.99998 8.99998L6.00001 6.00001M6.00001 6.00001L3 3M6.00001 6.00001L9.00002 3M6.00001 6.00001L3 9.00002"
                                                  stroke="#013159"
                                                  strokeWidth="1.5"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>
                                            </button>
                                          ))
                                        )}
                                      </div>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                      >
                                        <path
                                          d="M13.3332 8.3335L9.99984 11.6668L6.6665 8.3335"
                                          stroke="#013159"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </Dropdown.Toggle>

                                    {location.country && (
                                      <Dropdown.Menu>
                                        <div className="maintextdrop">
                                          <div className="mainsinputsssss">
                                            <input
                                              ref={cityInputRef} // Attach ref
                                              type="text"
                                              placeholder="Search..."
                                              value={location.searchTermCity}
                                              onChange={(e) => {
                                                const term = e.target.value;
                                                setLocations(
                                                  locations.map((loc) =>
                                                    loc.id === location.id
                                                      ? {
                                                        ...loc,
                                                        searchTermCity: term,
                                                      }
                                                      : loc
                                                  )
                                                );
                                              }}
                                            />
                                          </div>
                                          <div className="parentchec">
                                            {(allCities[location.country] || [])
                                              .filter((city) =>
                                                city
                                                  .toLowerCase()
                                                  ?.includes(
                                                    location.searchTermCity.toLowerCase()
                                                  )
                                              )
                                              .map((city, index) => (
                                                <div
                                                  key={index}
                                                  className="mainchec"
                                                >
                                                  <div className="checkboxmainss">
                                                    <label
                                                      className="checkbox"
                                                      htmlFor={`${location.id}-${city}`}
                                                    >
                                                      <input
                                                        type="checkbox"

                                                        id={`${location.id}-${city}`}
                                                        checked={location.cities?.includes(
                                                          city
                                                        )}
                                                        onChange={() =>
                                                          handleCityToggle(
                                                            location.id,
                                                            city
                                                          )
                                                        }
                                                      />
                                                      <span className="checkmark"></span>
                                                    </label>
                                                    <p className="checkboxpara">
                                                      {city}
                                                    </p>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                        </div>
                                      </Dropdown.Menu>
                                    )}
                                  </Dropdown>
                                </div>
                              </div>

                              {/* Close Button for additional locations */}
                              <div
                                className={
                                  index > 0
                                    ? "seconddddddddd"
                                    : "seconddddddddd invisible"
                                }
                              >
                                <div
                                  className="red"
                                  onClick={() => removeLocation(location.id)}
                                >
                                  <div className="close">
                                    <img
                                      src="\assets\Close_MD.png"
                                      alt="close"
                                      className="innerclose"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                          {/* Add Another Location Button */}
                          <div className="locationbtn">
                            {/* {console.log(
                              "Locationssssss at button click are:",
                              locations
                            )} */}
                            <button onClick={addLocation}>
                              Add Another Location
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-container">
          <div className="savebutton">
            {
              <button
                onClick={() => aditProfile()}
                disabled={!isFormValid}
                style={{
                  opacity: isFormValid ? 1 : 0.5,
                  cursor: isFormValid ? "pointer" : "not-allowed"
                }}
              >
                Save
              </button>
            }
          </div>
        </div>
      </section>

      <Modal
        show={show6}
        onHide={() => setShow6(false)}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect
                x="28.2036"
                y="49.8564"
                width="2"
                height="40.2235"
                transform="rotate(-135 28.2036 49.8564)"
                fill="#013159"
              />
              <rect
                x="17"
                y="38.625"
                width="2"
                height="15.43"
                transform="rotate(-45 17 38.625)"
                fill="#013159"
              />
            </svg>
            <h1>Your Participant Profile has been updated successfully</h1>
            {/* <p className="parssa">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            {/* ; handleShow79 () */}
            <button
              className="surebutton"
              onClick={() => {
                setShow6(false);
              }}
            >
              OK
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal className="verify" show={show77} onHide={handleClose77} centered>
        <Modal.Header closeButton>
          <Modal.Title>Verify Email Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="contentmain">
            <h3>Verify your email address</h3>
            <p>
              We emailed you a six-digit code to <span>{email}</span>. Enter the
              code below to confirm your email address.
            </p>
            <div className="sixinputs">
              {otp?.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  value={digit}
                  maxLength={1}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleOtpBackspace(e, index)}
                />
              ))}
            </div>
            <div className="twicebuttonssss">
              <button className="cancle" onClick={handleClose77}>
                Cancel
              </button>
              <button
                className="verify"
                onClick={() => {
                  setOtp(["", "", "", "", "", ""]);
                  verifyOtp();
                }}
              >
                Verify
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="verify" show={show78} onHide={handleClose78} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="contentmain forpaddddd">
            <div className="mainimages">
              <img
                src="\assets\dummy\tick.png"
                alt="img"
                className="img-fluid tick"
              />
            </div>
            <h4 className="verifytext">Email verified successfully</h4>
            <button
              className="ok"
              onClick={() => {
                // handleShow79();
                handleClose78();
              }}
            >
              OK
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="verify" show={show79} onHide={handleClose79} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="contentmain forpaddddd">
            <div className="mainimages">
              <img
                src="\assets\dummy\tick.png"
                alt="img"
                className="img-fluid tick"
              />
            </div>
            <h4 className="verifytext">
              Your Participant Profile has been updated successfully
            </h4>
            <div className="twicebuttonssss">
              <button onClick={handleClose79} className="close">
                Close
              </button>
              <button className="verify" onClick={handleClose6}>
                View Relevant Tasks
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Editprofile;